import { render, staticRenderFns } from "./ListModules.vue?vue&type=template&id=bc98d6d2"
import script from "./ListModules.vue?vue&type=script&lang=js"
export * from "./ListModules.vue?vue&type=script&lang=js"
import style0 from "./ListModules.vue?vue&type=style&index=0&id=bc98d6d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports